import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Bubble, LoaderButton } from 'ctia-ui';
import { requestStatuses } from 'helpers/RequestHelper';
import DeviceTable from 'containers/Devices/DeviceTable';
import {
  Col,
  Row,
  Form,
  FormGroup,
  FormControl,
  ControlLabel
} from 'react-bootstrap';
import { clearDeviceList } from 'actions/devices';
import { startPreloader, finishPreloader } from 'actions/preloader';

class DeviceList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filterTerm: '',
      status: requestStatuses.approved
    };
  }

  componentDidUpdate(prevProps) {
    const { devices } = this.props;
    if (
      _.has(devices, 'term') &&
      _.has(prevProps.devices, 'term') &&
      devices.term !== prevProps.devices.term
    ) {
      // this.setState({ searchTerm: devices.term });
      // reset optional search term
      this.setState({ filterTerm : '' });
    }
  }

  changeHandler = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  startSearchResult = (list, term) => {
    return _.filter(list, device => {
      // need to convert any UPPER CASE to lower case first
      const modelName = String(device.modelnumber).toLowerCase();
      const manuName = String(device.name).toLowerCase();
      return modelName.indexOf(term.toLowerCase()) !== -1 || manuName.indexOf(term.toLowerCase()) !== -1;
    });
  };

  render() {
    const { devices, user } = this.props;

    if (!devices || !devices.list) {
      return null;
    }

    const { list } = devices;
    const { filterTerm } = this.state;
    const deviceList = this.startSearchResult(list, filterTerm);

    return (
      <div>
        <LoaderButton
          text="&larr; Return to Search"
          style={{ marginBottom: 15 }}
          onClick={this.props.clearDeviceList}
        />
        <Bubble>
          Below is a list of the certified devices. Select a device and click on
          the <strong>Model Name/Number</strong> to see all certified
          Hardware/Software versions.
          <br />
          Search within the list of certified devices by entering the search
          term(s) and clicking <strong>Search</strong>.
        </Bubble>
        <Row>
          <Col xs={8} sm={6} md={9}>
            <Form inline bsSize="small">
              <FormGroup controlId="filterTerm" bsSize="small">
                <ControlLabel bsSize="small">
                  Enter Any Optional Search Terms:
                </ControlLabel>{' '}
                <FormControl
                  type="text"
                  value={filterTerm}
                  onChange={this.changeHandler}
                  style={{ width: 250 }}
                />
              </FormGroup>
            </Form>
          </Col>
          <Col xs={4} sm={6} md={3} className="text-right">
            <ControlLabel>Total records:</ControlLabel> {deviceList.length}
          </Col>
        </Row>
        <hr />
        <DeviceTable list={deviceList} hideVendors={user.isVendor} />
      </div>
    );
  }
}

function mapStateToProps({ devices, user, preloader }) {
  return { devices, user, preloader };
}

export default connect(
  mapStateToProps,
  {
    clearDeviceList,
    startPreloader,
    finishPreloader
  }
)(DeviceList);



// WEBPACK FOOTER //
// ./src/containers/Devices/DeviceList.js